(function () {
  var STAR_SELECTOR = [
    '.jdgm-widget .jdgm-star',
    '.jdgm-widget [class*="star" i]',
    '.jdgm-carousel-wrapper .jdgm-star',
    '.jdgm-carousel-wrapper [class*="star" i]'
  ].join(',');

  var css = [
    ':root{--tcs-star-font:Georgia,"Times New Roman",Times,serif;}',
    '.tcs-review-star-icons{display:inline-flex!important;align-items:center!important;gap:.12em!important;font-family:var(--tcs-star-font)!important;font-size:16px!important;line-height:1!important;letter-spacing:0!important;text-transform:none!important;}',
    '.tcs-review-star-icon{display:inline-block!important;font-family:var(--tcs-star-font)!important;font-size:1em!important;font-style:normal!important;font-variant:normal!important;font-weight:400!important;line-height:1!important;letter-spacing:0!important;text-transform:none!important;}',
    '.tcs-review-star-icon:before{content:"\\2605"!important;}',
    '.rating-star,.rating-star:before,.tcs-product-offer__stars,.tcs-product-offer__stars *,.tcs-review-star-icons,.tcs-review-star-icons *,.jdgm-widget .jdgm-star,.jdgm-widget .jdgm-star:before,.jdgm-widget .jdgm-star:after,.jdgm-carousel-wrapper .jdgm-star,.jdgm-carousel-wrapper .jdgm-star:before,.jdgm-carousel-wrapper .jdgm-star:after{font-family:var(--tcs-star-font)!important;font-style:normal!important;font-variant:normal!important;font-weight:400!important;line-height:1!important;text-transform:none!important;}',
    '.jdgm-widget .jdgm-star,.jdgm-carousel-wrapper .jdgm-star{display:inline-block!important;width:1em!important;min-width:1em!important;overflow:hidden!important;font-size:0!important;letter-spacing:0!important;vertical-align:baseline!important;}',
    '.jdgm-widget .jdgm-star:before,.jdgm-carousel-wrapper .jdgm-star:before{content:"\\2605"!important;display:inline-block!important;font-family:var(--tcs-star-font)!important;font-size:16px!important;letter-spacing:0!important;}',
    '.jdgm-widget .jdgm-star.jdgm--off:before,.jdgm-carousel-wrapper .jdgm-star.jdgm--off:before{opacity:.22!important;}'
  ].join('');

  var refreshTimer = null;

  function installGuard() {
    var style = document.getElementById('tcs-font-star-guard-runtime');
    if (!style) {
      style = document.createElement('style');
      style.id = 'tcs-font-star-guard-runtime';
      document.head.appendChild(style);
    }
    if (style.textContent !== css) style.textContent = css;
  }

  function isBoxGlyphText(text) {
    var value = (text || '').trim();
    return value.length > 0 && value.length <= 8 && /[\uE000-\uF8FF\u25A1\u25A0\u25AB\u25AD\u25AF\uFFFD]/.test(value);
  }

  function buildStars(count) {
    var wrap = document.createElement('span');
    wrap.className = 'tcs-review-star-icons';
    wrap.setAttribute('aria-hidden', 'true');

    for (var index = 0; index < count; index += 1) {
      var star = document.createElement('span');
      star.className = 'tcs-review-star-icon';
      wrap.appendChild(star);
    }

    return wrap;
  }

  function replaceLeafStar(element) {
    if (!element || element.dataset.tcsReviewStars === 'true') return;
    if (element.children.length > 0 && !element.classList.contains('jdgm-star')) return;
    if (!element.closest('.jdgm-widget, .jdgm-carousel-wrapper')) return;

    var text = element.textContent || '';
    var className = String(element.className || '').toLowerCase();
    var looksLikeStar = className.indexOf('star') !== -1 || isBoxGlyphText(text);

    if (!looksLikeStar) return;

    element.dataset.tcsReviewStars = 'true';

    if (element.classList.contains('jdgm-star')) {
      element.textContent = '';
      return;
    }

    if (isBoxGlyphText(text)) {
      var count = Math.max(1, Math.min(5, text.trim().length));
      element.textContent = '';
      element.appendChild(buildStars(count));
    }
  }

  function replaceReviewStars(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var elements;

    try {
      elements = scope.querySelectorAll(STAR_SELECTOR);
    } catch (error) {
      elements = [];
    }

    elements.forEach(replaceLeafStar);
  }

  function refresh(root) {
    installGuard();
    replaceReviewStars(root);
  }

  function scheduleRefresh(root) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(function () {
      refresh(root || document);
    }, 100);
  }

  refresh(document);
  document.addEventListener('DOMContentLoaded', function () { refresh(document); });
  document.addEventListener('shopify:section:load', function (event) { refresh(event.target || document); });
  window.addEventListener('load', function () { refresh(document); });
  window.setTimeout(function () { refresh(document); }, 800);
  window.setTimeout(function () { refresh(document); }, 2500);

  if ('MutationObserver' in window) {
    var observer = new MutationObserver(function () {
      scheduleRefresh(document);
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  }
})();
